import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-transport-name',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './transport-name.component.html',
  styleUrls: ['./transport-name.component.scss'],
})
export class TransportNameComponent  {
  public transportName = input<string>();
}
